import {Pipe, PipeTransform} from '@angular/core'

import {MainHelper} from "../models/main-helper";

@Pipe({ name: 'dateConv'})
export class DateConvPipe implements PipeTransform  {
    transform(date: string, locale: string): string {
        return MainHelper.convertDate(date, locale);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/date-conv.pipe.ts